import axios from 'axios';




const getApiConfig = (portal) =>{

    let authUser = JSON.parse(localStorage.authUser);
            
    let api = axios.create({
        baseURL: portal.url,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With' : portal.portalId,
        },
    });
    return api;
}


const getPortalList = (id) =>{
    const api = axios.create({
        baseURL: "https://auth-k.gtoken.in/",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });

    return new Promise((resolve, reject)=>{
        api.get("/portal/list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :"res.data.msg"
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })

}


const getValidity = (portal) =>{
    let api = getApiConfig(portal);
    return new Promise((resolve, reject)=>{
        api.get("/validity/get").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })

}



const validityRequestOtp = (portal) => {
    let api = getApiConfig(portal);
    return new Promise((resolve, reject)=>{
        api.post("validity/requestOtp").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const validityUpdate = (portal,payload) => {
    let api = getApiConfig(portal);
    return new Promise((resolve, reject)=>{
        api.post("validity/update",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const validityAdminServices = {
    getPortalList,
    getValidity,
    validityRequestOtp,
    validityUpdate
}
export default validityAdminServices;






